module.exports = __webpack_public_path__ + "media/ms-name.b579a282.mp3";